import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./latest_news.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://api.mitadtu.in";

const LatestNews = () => {
  const navigate = useNavigate();

  const [examNotices, setExamNotices] = useState([]);
  const [examTimetables, setExamTimetables] = useState([]);
  const [happeningsData, setHappeningsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        // Fetch exam notices
        const resExam = await fetch(
          `${API_BASE}/api/admin/exam-notices/public`,
        );
        const dataExam = await resExam.json();
        const notices = (dataExam.data || []).filter(
          (item) => item.category === "notice",
        );
        const timetables = (dataExam.data || []).filter(
          (item) => item.category === "timetable",
        );
        setExamNotices(notices);
        setExamTimetables(timetables);

        // Fetch happenings
        const resLatest = await fetch(
          `${API_BASE}/api/admin/latest-news/public`,
        );
        const dataLatest = await resLatest.json();
        setHappeningsData(dataLatest.happenings || []);
      } catch (err) {
        console.error("Error fetching latest news:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return { month: "", day: "" };

    const dateObj = new Date(dateStr);
    if (isNaN(dateObj)) return { month: "", day: "" };

    return {
      month: dateObj.toLocaleString("default", { month: "short" }),
      day: dateObj.getDate(),
    };
  };

  const renderExamItem = (item) => {
    const { month, day } = formatDate(item.news_date);
    return (
      <div key={item.id} className="news-item">
        <div className="news-date">
          <span className="month">{month}</span>
          <span className="day">{day}</span>
        </div>
        <div>
          <p className="news-content">{item.news_title}</p>
          {(item.file_path || item.link_url) && (
            <a
              href={item.file_path ? `${API_BASE}${item.file_path}` : item.link_url}
              className="news-link"
              target="_blank"
              rel="noreferrer"
            >
              {item.link_text || 'Click here'}
            </a>
          )}
        </div>
      </div>
    );
  };

  const uniqueHappenings = Object.values(
    happeningsData.reduce((acc, item) => {
      if (!acc[item.display_order]) {
        acc[item.display_order] = item;
      }
      return acc;
    }, {}),
  );

  const sortedHappenings = uniqueHappenings.sort(
    (a, b) => a.display_order - b.display_order,
  );

  //   const { month, day } = formatDate(item.news_date);
  //   const photos = Array.isArray(item.news_photo) ? item.news_photo : [];
  //   const firstPhoto = photos.length > 0 ? photos[0] : null;

  //   return (
  //     <div key={item.id} className="happening-item">
  //       <div
  //         style={{
  //           display: "flex",
  //           justifyContent: "space-between",
  //           alignItems: "center",
  //           marginBottom: "8px",
  //         }}
  //       >
  //         <p className="happening-content" style={{ margin: 0, flex: 1 }}>
  //           {item.news_title}
  //         </p>
  //         {item.news_date && (
  //           <p
  //             className="happening-date"
  //             style={{ margin: 0, marginLeft: "10px", whiteSpace: "nowrap" }}
  //           >
  //             {item.news_date}
  //           </p>
  //         )}
  //       </div>
  //       {firstPhoto && (
  //         <img
  //           src={`${API_BASE}${firstPhoto}`}
  //           alt={item.news_title}
  //           className="happening-image"
  //         />
  //       )}
  //     </div>
  //   );
  // };

  // const renderHappeningItem = (item) => {
  //   const photos = Array.isArray(item.news_photo) ? item.news_photo : [];
  //   const firstPhoto = photos.length > 0 ? photos[0] : null;

  //   return (
  //     <div
  //       key={item.id}
  //       className="happening-item"
  //       onClick={() => navigate(`/lifeatcampus/Happenings/${item.id}`)}
  //       style={{ cursor: "pointer" }}
  //     >
  //       <div
  //         style={{
  //           display: "flex",
  //           justifyContent: "space-between",
  //           alignItems: "center",
  //           marginBottom: "8px",
  //         }}
  //       >
  //         <p className="happening-content" style={{ margin: 0, flex: 1 }}>
  //           {item.news_title}
  //         </p>

  //         {item.news_date && (
  //           <p
  //             className="happening-date"
  //             style={{ margin: 0, marginLeft: "10px", whiteSpace: "nowrap" }}
  //           >
  //             {item.news_date}
  //           </p>
  //         )}
  //       </div>

  //       {firstPhoto && (
  //         <img
  //           src={`${API_BASE}${firstPhoto}`}
  //           alt={item.news_title}
  //           className="happening-image"
  //         />
  //       )}
  //     </div>
  //   );
  // };

  return (
    <div className="news-main-container">
      <div className="news-left-container">
        <h1 className="title">Latest News & Announcement</h1>
        <h2 className="subtitle">
          Academic highlights to Exam Alerts- All in One Place !.
        </h2>

        <div className="news-columns">
          {/* Exam Notices */}
          <div className="news-column">
            <h3 className="news-title">Academics Notices</h3>
            <div className="news-frame">
              <div className="news-list">
                {loading ? "Loading..." : examNotices.length > 0
                  ? [...examNotices, ...examNotices].map((item, i) => (
                    <div key={i}>{renderExamItem(item)}</div>
                  ))
                  : <div className="news-item">No exam notices available.</div>}
              </div>
            </div>
            <button id="news-btn" onClick={() => navigate("/examinations/notices", { state: { category: "notice" } })}>
              View All
            </button>
          </div>

          {/* Exam Timetables */}
          <div className="news-column">
            <h3 className="news-title">Examination Time-Table</h3>
            <div className="news-frame">
              <div className="news-list">
                {loading ? "Loading..." : examTimetables.length > 0
                  ? [...examTimetables, ...examTimetables].map((item, i) => (
                    <div key={i}>{renderExamItem(item)}</div>
                  ))
                  : <div className="news-item">No exam timetables available.</div>}
              </div>
            </div>
            <button id="news-btn" onClick={() => navigate("/examinations/exam-timetable", { state: { category: "timetable" } })}>
              View All
            </button>
          </div>
        </div>
      </div>

      {/* Happenings */}
      <div className="news-right-container">
        <h3 className="happenings-title">Happenings</h3>
        <p>Catch every event for shaping our journey</p>

        <div className="happenings-scroll">
          <div className="happenings-track">
            {[...sortedHappenings, ...sortedHappenings].map((item, index) => (
              <div key={index} className="happening-item">
                <div className="happening-header">
                  <p
                    className="happening-content"
                    onClick={() =>
                      navigate(`/lifeatcampus/happenings/${item.id}`)
                    }
                  >
                    {item.news_title}
                  </p>

                  {item.news_date && (
                    <p className="happening-date">{item.news_date}</p>
                  )}
                </div>

                {Array.isArray(item.news_photo) &&
                  item.news_photo.length > 0 && (
                    <img
                      src={`${API_BASE}${item.news_photo[0]}`}
                      onClick={() =>
                        navigate(`/lifeatcampus/happenings/${item.id}`)
                      }
                      alt={item.news_title}
                      className="happening-image"
                    />
                  )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatestNews;
